import styled from "styled-components";
import { colors } from "@/theme";

export const ChannelsRadioGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ChannelsRadioGroupHeader = styled.div`
  color: ${colors.fieldTextHelper};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
`;

interface ChannelRadioItemContainerProps {
  checked?: boolean;
}

export const ChannelRadioItemContainer = styled.div<ChannelRadioItemContainerProps>`
  display: grid;
  grid-template-columns: auto 50px;
  padding: 16px;
  border: ${`1px solid ${colors.black}`};
  border-radius: 12px;
  ${(props) => props.checked && "background-color: rgba(51, 122, 206, 0.1);"}
`;
